import React from "react";

export default function EligibilityBadge({
  eligible,
  reason,
}: {
  eligible: boolean;
  reason?: string | null;
}) {
  return (
    <span
      title={!eligible ? reason || "Not eligible" : "Eligible"}
      className={[
        "inline-flex items-center rounded-full px-2 py-1 text-xs font-medium",
        eligible
          ? "bg-emerald-50 text-emerald-700"
          : "bg-rose-50 text-rose-700",
      ].join(" ")}
    >
      {eligible ? "Eligible" : "Not eligible"}
    </span>
  );
}
